export default (() => {
  class FormGotafeCustom {
    constructor($form) {
      this.$form = $form;
      this.freeTafeCourses_count = 0;
    }

    init() {
      var self = this;

      self.freeTafeCourses('input[type="checkbox"][name="freeTafeCourses[]"]');
    }

    freeTafeCourses(checkboxesSelector) {
      var self = this;

      self.freeTafeCourseLogic(checkboxesSelector); // Page load

      self.$form.find(checkboxesSelector).on('change', function() { // On checbox change
        self.freeTafeCourseLogic(checkboxesSelector);
      });
    }

    freeTafeCourseLogic(checkboxesSelector) {
      var self = this;

      this.freeTafeCourses_count = self.$form.find(checkboxesSelector + ':checked').length;
      if(this.freeTafeCourses_count == 5) {
        self.$form.find(checkboxesSelector + ':not(:checked)').attr('disabled', true);
      } else {
        self.$form.find(checkboxesSelector).removeAttr('disabled');
      }
    }
  }

  // Process all <form> on page
  $('form').each(function() {
      var formGotafeCustom = new FormGotafeCustom($(this), true);
      formGotafeCustom.init();
  });

})();
